import { SearchUsers } from '@platform/client';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { AuthedPage, HeaderFooterLayout } from '../../app';
import { LanguageSelectionDropdown } from '../../components/LanguageSelectionDropdown';
import { PaginationBar } from '../../components/PaginationBar';
import { SkillsSelectionDropdown } from '../../components/SkillsSelectionDropdown';
import { UserCard } from './UserCard';

const UserPageSize = 50;

const UserSearch = () => {
  const [languageSelection, setLanguageSelection] = useState<string[]>([]);
  const [skillSelection, setSkillSelection] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const userData = SearchUsers.useSearchProUsers({
    languages: languageSelection.join(';'),
    skills: skillSelection.join(';'),
    page: currentPage,
    limit: UserPageSize,
  });

  const numUsers = userData.data?.filteredCount || 0;
  const numPages = Math.ceil(numUsers / UserPageSize);

  const onPageSelect = (page: number) => {
    setCurrentPage(page - 1);
  };

  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='flex flex-col gap-4 p-6'>
          <div className='text-4xl font-semibold text-gray-900'>
            Find a professional to help with your project
          </div>
          <div className='flex flex-col md:flex-row md:gap-4 text-lg'>
            <div className='w-[350px] p-2'>
              <LanguageSelectionDropdown
                selectedLanguages={languageSelection}
                onLanguageSelectionChange={setLanguageSelection}
                label='What languages do you prefer?'
              />
            </div>
            <div className='w-[350px] p-2'>
              <SkillsSelectionDropdown
                selectedSkills={skillSelection}
                onSkillsSelectionChange={setSkillSelection}
                label='What skills are you looking for?'
              />
            </div>
          </div>

          {userData.isSuccess && (
            <div className='grid grid-cols-1 md:grid-cols-3 bg-gray-50 gap-6 py-10 px-4'>
              {userData.data.users.map((user) => {
                return <UserCard user={user} />;
              })}
            </div>
          )}
          {!userData.isSuccess && <Skeleton />}
          <PaginationBar
            numPages={numPages}
            currentPage={currentPage + 1}
            onPageSelect={onPageSelect}
          />
        </div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default UserSearch;
